<template>
    <v-card class="justify-center">
        <v-toolbar
            color="primary"
            class="toolbar--wraped"
            dark
            flat
        >
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer />
            <v-btn
              icon
              color="white"
              @click="$emit('close')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <video controls autoplay style="width: 100%">
            <source :src="`https://s3.amazonaws.com/files.kaoshinetwork.com/videos/coming-soon${videoSrc}`" type="video/mp4">
            Sorry, your browser doesn't support embedded videos.
        </video>

        <v-col cols="8" class="mx-auto" :class="{ loading: loading }">
            <v-form
                @submit.prevent="onSubmit"
                class="justify-center py-3"
            >
                <v-row class="justify-center">
                    <v-text-field
                        autofocus
                        aria-required
                        required
                        style="height: 74px;"
                        name="email"
                        v-model="email"
                        v-validate="'required|email'"
                        validate-on-blur
                        :error-messages="errors.first('email')"
                        type="email"
                        label="Your Email Address"
                        append-icon="mdi-email-outline"
                        background-color="#fcfcfc"
                        outlined
                        ref="email"
                    />
                    <v-btn
                        class="px-12 ml-3 mt-1 text--white"
                        :color="!reCaptchaToken ? '#ccc' : 'primary'"
                        dark
                        depressed
                        large
                        :readonly="!reCaptchaToken"
                        type="submit"
                    >
                        Join
                    </v-btn>
                </v-row>
                <p class="title font-weight-bold green--text mt-2 text-center">It is not too late to join the wait list!</p>
                <v-row class="justify-center">
                    <vue-recaptcha
                        ref="recaptcha"
                        :sitekey="sitekey"
                        :loadRecaptchaScript="true"
                        @verify="onReCaptchaVerify"
                        @expired="onReCaptchaExpired"
                    />
                </v-row>
            </v-form>
        </v-col>
    </v-card>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import VueRecaptcha from 'vue-recaptcha';

export default {
    props: {
        title: String,
        videoSrc: String,
        loading: Boolean,
    },
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            sitekey: process.env.MIX_RE_CAPTCHA_SITE_KEY,
            email: this.isUserAuthenticated ? this.$store.state.user.email : null,
            reCaptchaToken: false,
        };
    },
    methods: {
        onReCaptchaVerify(token) {
            console.log('verified');
            this.reCaptchaToken = token;
        },
        onReCaptchaExpired() {
            this.reCaptchaToken = false;
        },
        onSubmit() {
            if (this.reCaptchaToken) {
                this.$emit('submit', {
                    email: this.email,
                    reCaptchaToken: this.reCaptchaToken,
                });
            }
        },
    },
    watch: {
        loading: function() {
            this.$refs.recaptcha.reset();
            this.reCaptchaToken = false;
        },
    },
    computed: {
        ...mapGetters([
            'isUserAuthenticated',
        ]),
    },
}
</script>

<style scoped>
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
</style>
